module.exports = __webpack_public_path__ + "static/media/Header-img.e15941b9.png";